import React, { useState } from "react";
import {
  Grid,
  Card,
  Step,
  Stepper,
  StepLabel,
} from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import Header from "layouts/pages/profile/components/Header";
import About from "./about";
import PrivateCloudConfig from "./configur";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function getStepContent(stepIndex, handleNext, handleBack) {
  switch (stepIndex) {
    case 0:
      return <About onNext={handleNext} />;
    case 1:
      return <PrivateCloudConfig onBack={handleBack} />;
    default:
      return "Unknown step";
  }
}

function PrivateCloudWizard() {
  const [activeStep, setActiveStep] = useState(0);
  const steps = ["Übersicht", "Konfiguration"];

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <SoftBox mb={3} p={1}>
              <SoftTypography
                variant="h3"
                textAlign="center"
                fontWeight="bold"
                color="dark"
              >
                UDS Private Cloud
              </SoftTypography>
              <SoftTypography
                variant="h5"
                mt={1}
                textAlign="center"
                fontWeight="regular"
                color="text"
              >
                Ihre eigene private Cloud für maximale Kontrolle und Sicherheit
              </SoftTypography>
            </SoftBox>

            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <Card>
              <SoftBox p={2}>
                <SoftBox>
                  {getStepContent(activeStep, handleNext, handleBack)}
                </SoftBox>
              </SoftBox>
            </Card>
          </Grid>
        </Grid>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default PrivateCloudWizard;